var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"vue-go-top"}},[_c('a',{staticClass:"to-top",class:{ 'd-block': _vm.isActive },on:{"click":_vm.GoTop}},[_c('i',{staticClass:"fa fa-angle-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }